module.exports = __webpack_public_path__ + "static/media/data-validation-tool.e13bc912.svg";